import React from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import { LocaleProvider } from 'antd'
import zhCN from 'antd/lib/locale-provider/zh_CN'
import { PublicLayout, ProtectedLayout } from 'layouts'
import UserContext, { IUserContext } from 'modules/User/UserContext'
import { getUserRoute } from 'services/permission'
import api from 'api'
import ModelingLayout from 'layouts/ModelingLayout'
interface RouterState {
  routes: IRoute[]
}
export default class extends React.Component<IUserContext, RouterState> {
  state: RouterState = { routes: [] }

  constructor(props: any) {
    super(props)
  }
  render() {
    const routes = getUserRoute()

    let loginRoute: IRoute
    let publicRoutes: IRoute[] = []
    let protectedRoutes: IRoute[] = []
    let modelingRoutes: IRoute[] = []

    for (let route of routes) {
      if (route.path === '/login') {
        loginRoute = route
      }
      if (route.layout === 'public') {
        publicRoutes.push(route)
      } else if (route.layout === 'modeling') {
        modelingRoutes.push(route)
      } else {
        protectedRoutes.push(route)
      }
    }
    return (
      <LocaleProvider locale={zhCN}>
        <BrowserRouter>
          <Switch>
            <Route path="/login" render={props => <PublicLayout {...props} route={loginRoute} />} />
            {publicRoutes.map((route, index) => {
              return (
                <Route
                  exact
                  key={route.path}
                  path={route.path}
                  render={props => <PublicLayout {...props} route={route} />}
                />
              )
            })}
            {modelingRoutes.map((route, index) => {
              return (
                <Route
                  exact
                  key={route.path}
                  path={route.path}
                  render={props => <ModelingLayout {...this.props} {...props} routeData={[route]} />}
                />
              )
            })}
            <Route
              path="/"
              render={props => <ProtectedLayout {...this.props} {...props} routeData={protectedRoutes} />}
            />
          </Switch>
        </BrowserRouter>
      </LocaleProvider>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Router.tsx